import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './features/auth/Login';
import DashboardLayout from './components/layout/DashboardLayout';

function App() {
  const { user, loading, isRecovery } = useAuth();

  // Si está cargando, mostramos un indicador simple para confirmar que la app inició
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        backgroundColor: '#000', 
        color: '#fff',
        fontFamily: 'sans-serif'
      }}>
        Cargando MSC Rewards...
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Raíz: Redirige siempre al login por defecto */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        
        {/* LOGIN y RECUPERACIÓN */}
        <Route 
          path="/login" 
          element={
            isRecovery 
              ? <Navigate to="/change-password" replace /> 
              : (!user ? <Login /> : <Navigate to="/main" replace />)
          } 
        />
        
        {/* CAMBIO DE CONTRASEÑA: Solo si viene de un link de recuperación */}
        <Route 
          path="/change-password" 
          element={
            isRecovery 
              ? <Login forcedView="update" /> 
              : <Navigate to="/login" replace />
          } 
        />
        
        {/* DASHBOARD PRINCIPAL: Protegido */}
        <Route 
          path="/main" 
          element={
            (user && !isRecovery) 
              ? <DashboardLayout /> 
              : <Navigate to="/login" replace />
          } 
        />

        {/* CUALQUIER OTRA RUTA: Al login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;